import React from 'react';
import { motion } from 'framer-motion';
import './LegalPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="legal-page">
      {/* Hero */}
      <section className="legal-hero">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Gizlilik Politikası
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Son Güncelleme: 01.12.2025
          </motion.p>
        </div>
      </section>

      {/* Content */}
      <section className="legal-content">
        <div className="container">
          <motion.div
            className="legal-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="intro">
              BMK Eğitim Kurumları ("Kurum") olarak, web sitemizi (bundan böyle "Site" olarak anılacaktır) 
              ziyaret eden kullanıcılarımızın gizliliğine önem veriyoruz. Bu Gizlilik Politikası, sitemizi 
              ziyaret ettiğinizde hangi bilgilerin toplandığını ve bu bilgilerin nasıl korunduğunu açıklar.
            </p>

            <div className="legal-section">
              <h2>1. Toplanan Bilgiler ve Log Dosyaları</h2>
              <p>
                Birçok standart web sunucusu gibi, BMK Eğitim Kurumları web sitesi de istatistiksel amaçlarla 
                log dosyaları kaydı tutabilir. Bu dosyalar; IP adresiniz, internet servis sağlayıcınız, 
                tarayıcınızın özellikleri, işletim sisteminiz ve siteye giriş-çıkış sayfalarınız gibi standart 
                bilgileri içerir.
              </p>
              <p>
                Log dosyaları kesinlikle istatistiksel amaçlar dışında kullanılmamakta ve mahremiyetinizi 
                ihlal etmemektedir. IP adresiniz ve diğer bilgiler, kişisel bilgilerinizle ilişkilendirilmemektedir.
              </p>
            </div>

            <div className="legal-section">
              <h2>2. Çerezler (Cookies)</h2>
              <p>
                Web sitemiz, kullanıcı deneyimini iyileştirmek, sitenin verimli çalışmasını sağlamak veya 
                kullanıcı tercihlerini hatırlamak amacıyla "Çerez" (Cookie) adı verilen küçük metin dosyaları 
                kullanabilir. Çerezler, bilgisayarınızda veya mobil cihazınızda saklanan basit metin dosyalarıdır.
              </p>
              <p>
                Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman engelleyebilir veya silebilirsiniz. 
                Ancak çerezleri devre dışı bırakmak, sitenin bazı özelliklerinin düzgün çalışmamasına neden olabilir.
              </p>
            </div>

            <div className="legal-section">
              <h2>3. Kişisel Verilerin Toplanması (Formlar Aracılığıyla)</h2>
              <p>
                Sitemiz üzerinde yer alan "Bursluluk Sınavı Başvuru Formu" veya "İletişim Formu" gibi alanları 
                doldurduğunuzda; Ad, Soyad, Telefon, T.C. Kimlik No gibi kişisel verileriniz talep edilmektedir.
              </p>
              <p>
                Bu verilerin hangi amaçla toplandığı ve işlendiği, ilgili formun hemen altında yer alan 
                "KVKK Aydınlatma Metni" içerisinde detaylıca belirtilmiştir. Kullanıcı, formu doldurarak 
                bu metni okuduğunu ve kabul ettiğini beyan eder.
              </p>
            </div>

            <div className="legal-section">
              <h2>4. Dış Bağlantılar</h2>
              <p>
                BMK Eğitim Kurumları web sitesi, sayfalarından farklı internet adreslerine bağlantı verebilir. 
                Kurumumuz, link verdiği veya banner tanıtımını yaptığı sitelerin içeriklerinden veya gizlilik 
                prensiplerinden sorumlu değildir.
              </p>
            </div>

            <div className="legal-section">
              <h2>5. Güvenlik</h2>
              <p>
                Sitemiz üzerinden paylaşılan verilerin güvenliği için SSL (Secure Socket Layer) sertifikası 
                kullanılmaktadır. Bu teknoloji, verilerinizin şifrelenerek sunucularımıza iletilmesini sağlar. 
                Ancak, internet üzerinden veri aktarımının %100 güvenli olduğunun garanti edilemeyeceğini hatırlatırız.
              </p>
            </div>

            <div className="legal-section">
              <h2>6. İletişim</h2>
              <p>
                Gizlilik politikamızla ilgili her türlü soru, görüş ve düşüncelerinizi aşağıdaki kanallardan 
                bize iletebilirsiniz:
              </p>
              <ul className="contact-list">
                <li><strong>E-posta:</strong> bmkegitim@gmail.com</li>
                <li><strong>Adres:</strong> Huzurevleri, 77234. Sk. No:2, 01170 Çukurova/Adana</li>
              </ul>
            </div>

            <div className="legal-footer">
              <p><strong>BMK EĞİTİM KURUMLARI</strong></p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
